import React from 'react';
import NavTagline from '../nav-tagline/nav-tagline';
import Footer from './Footer';

const UnscheduledOutage = () => (
    <main className="UnscheduledOutage layout-container" aria-labelledby="unscheduledOutageHeading">
        <NavTagline />
        <div className="container ctr">
            <div className="text-size3 or-clr"><i className="bi bi-cone-striped" aria-hidden="true"></i></div>
            <p className="text-size4" id="unscheduledOutageHeading">We are currently working to update the domain certificate. <br />We will be back as soon as possible. {/*<p>We are currently undergoing unscheduled maintenance and will be back as soon as possible.</p>*/} Thank you for your patience!</p>
            <div className="text-size9 sp-margin10">If you need immediate support, please call{" "} <a href="tel:18884709913" aria-label="Call support at 1-888-470-9913">1.888.470.9913</a>{" "} or email us at{" "} <a href="mailto: support@secureexsolutions.com" aria-label="Email support at support@secureexsolutions.com">support@secureexsolutions.com</a>.</div>
        </div>
        <Footer />
  </main>
);


export default UnscheduledOutage;
